var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "スカウト＿テンプレート設定",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x align-justify" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "medium-3 cell" }, [
            _c(
              "button",
              {
                staticClass: "float-right boss-button boss-button-new",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      name: "settingScoutTemplateRegister",
                    })
                  },
                },
              },
              [
                _c("span", { staticClass: "boss-icon-new" }),
                _vm._v(" "),
                _c("span", { staticClass: "boss-button-new-text" }, [
                  _vm._v("新規作成する"),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.templates.length
          ? _c("table", { staticClass: "unstriped hover boss-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "boss-table-head-center" }, [
                    _vm._v("\n            テンプレート名\n          "),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "boss-table-head-center" }, [
                    _vm._v("\n            スカウト特典\n          "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "boss-table-head-center boss-update" },
                    [_vm._v("\n            最終更新者\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "boss-table-head-center boss-operation" },
                    [_vm._v("\n            編集\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "boss-table-head-center boss-copy" },
                    [_vm._v("\n            コピー\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "boss-table-head-center boss-operation" },
                    [_vm._v("\n            削除\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "boss-table-head-center boss-display-change",
                    },
                    [
                      _c("div", { staticClass: "pega-relative" }, [
                        _vm._v(
                          "\n              テンプレートへの表示/非表示\n              "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content:
                                    "非表示にすると「テンプレート」に反映されません",
                                },
                                expression:
                                  "{ content: '非表示にすると「テンプレート」に反映されません'}",
                              },
                            ],
                            staticClass: "pega-circle small-right-top",
                          },
                          [_vm._v("?")]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.templates, function (item) {
                  return _c(
                    "tr",
                    { key: item.id, attrs: { "data-test": "template-item" } },
                    [
                      _c(
                        "td",
                        {
                          staticClass: "boss-table-data",
                          attrs: { "data-test": "template-name-" + item.id },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "boss-table-data" },
                        _vm._l(item.specialFavors, function (favor, i) {
                          return _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: {
                                    content: _vm.specialFavorBy(favor.id)
                                      .description,
                                  },
                                  expression:
                                    "{ content: specialFavorBy(favor.id).description}",
                                },
                              ],
                              key: i,
                              staticClass:
                                "boss-bonus-check-text boss-check-true",
                              attrs: {
                                "data-test":
                                  "special-favor-" + item.id + "-" + favor.id,
                              },
                            },
                            [_vm._v(_vm._s(favor.name))]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "boss-table-data",
                          attrs: { "data-test": "modified-" + item.id },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.modified) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "boss-table-data" }, [
                        _c("button", {
                          staticClass: "boss-icon-pencil",
                          attrs: { "data-test": "template-edit" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                name: "settingScoutTemplateEdit",
                                params: { id: item.id },
                              })
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "boss-table-data" }, [
                        _c(
                          "div",
                          {
                            attrs: { "data-test": "template-copy" },
                            on: {
                              click: function ($event) {
                                return _vm.doCopy(item.id)
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass:
                                "boss-icon boss-icon-copy-regular boss-icon-copy",
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "boss-table-data" }, [
                        _c("button", {
                          staticClass: "boss-icon-trash",
                          attrs: { "data-test": "template-remove" },
                          on: {
                            click: function ($event) {
                              return _vm.doRemove(item.id)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "boss-table-data" }, [
                        _c("div", { staticClass: "switch toggle-switch" }, [
                          _c("input", {
                            staticClass: "toggle-input",
                            attrs: {
                              id: "toggle-" + item.id,
                              "data-test": "toggle-" + item.id,
                              type: "checkbox",
                            },
                            domProps: { checked: item.isDisplay },
                            on: {
                              change: function ($event) {
                                return _vm.changeDisplay(
                                  item.id,
                                  item.isDisplay
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", {
                            staticClass: "toggle-label",
                            attrs: { for: "toggle-" + item.id },
                          }),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ])
          : _c(
              "div",
              { staticClass: "grid-x grid-margin-y align-center margin-top-2" },
              [
                _c("span", { staticClass: "cell medium-4 subheader" }, [
                  _vm._v("テンプレートが作成されていません。"),
                ]),
              ]
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "medium-9 cell" }, [
      _c("p", [_vm._v("スカウト作成画面で使用するテンプレートを設定します。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }